import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';
import { EcmMaterialModule } from '@ecm/material';
import { LinkService, TrackingData } from '@ecm/router';

import { DashboardHelpsViewModel } from '../../../business/model/home/dashboard/dashboard-helps.view-model';
import { TrackedPage } from '../../../business/model/tracking/trackedPage.enum';
import { TrackingService } from '../../../services/tracking.service';
import { ImageUtils } from '../../../utils/image.utils';
import { AdviseWhitelistEclairConstants } from '../../shared/advise-whitelist-eclair.constants';

@Component({
    selector: 'push-helps[infos]',
    templateUrl: './push-helps.component.html',
    styleUrls: ['./push-helps.component.css'],
    standalone: true,
    imports: [NgTemplateOutlet, EcmMaterialModule, NgClass],
})
export class PushHelpsComponent implements OnInit {
    @Input()
    public isMobile: boolean;

    @Input()
    public isSoshBrand: boolean;

    protected readonly AdviseWhitelistEclairConstants = AdviseWhitelistEclairConstants;
    public zid!: string;
    public isEclair!: boolean;
    private readonly linkService = inject(LinkService);
    private readonly trackingService = inject(TrackingService);
    @Input()
    public infos!: DashboardHelpsViewModel[];

    public ngOnInit(): void {
        this.isEclair = EnvUtils.isEclair();
        if (this.infos) {
            for (const info of this.infos) {
                if (info.link) {
                    info.href = this.linkService.getLinkSync(info.link);
                }
                this.zid = this.trackingService.getTrackNamePerType(info.type, this.isMobile, this.isSoshBrand);
            }
        }
    }

    public openLink(info: DashboardHelpsViewModel) {
        this.linkService.openLink(
            info.link,
            Object.assign(new TrackingData(), {
                cappingTracking:
                    info.advTracker && info.advTracker.length > 0
                        ? {
                              advTracker: info.advTracker,
                              code: info.code,
                              cid: info.cid,
                          }
                        : null,
                tmsTracking: {
                    trackedPage: TrackedPage.dashboard,
                    trackingArea: 'care_hp_top_helping',
                    trackingName: info.code,
                },
            }),
        );
    }

    public getImgFormat(imgurl: string) {
        return ImageUtils.transformUrl(imgurl, '32');
    }
}
